import Page, { PageTab } from "../../../../shared/components/Page";
import UploadsListTab from "./UploadsListTab";
import UploadTab from "./UploadTab";

const tabs: PageTab[] = [
  {
    header: "Uploads",
    route: "app.uploads.list",
    component: <UploadsListTab />,
  },
  {
    header: "Authorization",
    route: "app.uploads.authorization",
    component: <UploadTab typeKey="AUTH_FILE" />,
  },
  { header: "AR notes", route: "app.uploads.arNotes", component: <UploadTab typeKey="AR_NOTES" /> },
];

export default function UploadsRoute() {
  return <Page.Tabbed tabs={tabs} />;
}
